import {
	REFRESH_PROFILE_VIEWS,
	SET_PROFILE_VIEWS,
} from './types'

const initialState = {
	categories: [],
	refresh: false,
	initialize: true
};

const reducer = (state = initialState, {type, payload}) => {

	switch (type) {

		case REFRESH_PROFILE_VIEWS:
			return {
				...state,
				refresh: true,
				initialize: true,
				views: [],
			}
		
		case SET_PROFILE_VIEWS:
			return {
				...state,
				refresh: false,
				initialize: false,
				views: payload
			}

		default:
			return state;

	}

}

export default reducer